import { ChangeDetectorRef, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { DirectusService } from './services/directus.service';
import { PushNotificationService } from './services/push-notifications.service';

import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { AuthModule } from '@angular/fire/auth';
import { databaseSettings } from 'src/environments/database-settings';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';
import { FormsModule } from '@angular/forms';
import { ErrorModalComponent } from './components/error-modal/error-modal.component';
import { Network } from '@ionic-native/network/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { PipeModule } from './pipes/pipe.module';
import { HeaderModule } from './components/header/header.module';
import { Header2Module } from './components/header2/header2.module';
import { SideMenuModule } from './components/side-menu/side-menu.module';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';

@NgModule({
  declarations: [AppComponent, ErrorModalComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot({
      name: '__mateo_db',
      driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage]
    }),
    AppRoutingModule,
    FormsModule,
    provideFirebaseApp(() => initializeApp(databaseSettings.firebase)),
    provideFirestore(() => getFirestore()),
    AuthModule,
    HttpClientModule,
    PipeModule,
    HeaderModule,
    Header2Module,
    SideMenuModule
  ],
  exports: [],
  providers: [
    StatusBar,
    SplashScreen,
    Network,
    DirectusService,
    PushNotificationService,
    HttpClient,
    InAppBrowser,

    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
